import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

@Component({
    selector: "sps-micro-zero-state",
    templateUrl: "./sps-micro-zero-state.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpsMicroZeroStateComponent {
    static readonly displayName = "sps-micro-zero-state";
    static readonly props = {
        icon: "string",
        heading: "string",
        subHeading: "string",
    };

    @Input() icon: string;
    @Input() heading: string;
    @Input() subHeading: string;
}
